document.addEventListener('click', function (e) {
  const link = e.target.closest('.header__submenu a');
  if (!link) return;

  // Stop native <details>/<summary> behavior
  e.preventDefault();
  e.stopImmediatePropagation();

  // Close the menu manually
  const details = link.closest('details');
  if (details) {
    details.removeAttribute('open');
  }

  // Navigate correctly
  window.location.href = link.href;
}, true);